import { useState, useEffect, useCallback } from 'react';

const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  const target = e.currentTarget;
  const container = target.closest('[data-img-wrapper]') as HTMLElement;
  if (container) {
    container.style.display = 'none';
  } else {
    target.style.display = 'none';
  }
};

const navLinks = [
  { label: '首页', href: 'hero' },
  { label: '关于神马', href: 'about' },
  { label: '最新动态', href: 'updates' },
  { label: '移动客户端', href: 'app' },
  { label: '焦点专题', href: 'carousel' },
  { label: '常见问题', href: 'faq' },
  { label: '热门话题', href: 'topics' },
];

const cardData = [
  {
    title: '香蕉视频精选',
    desc: '汇聚香蕉视频平台最新最热内容，每日精选推荐，让你不错过任何一部精彩影片，高品质观影体验触手可及。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20warm%20lighting%20abstract%20film%20reel%20glowing%20in%20amber%20tone%2C%20premium%20movie%20entertainment%20visual%2C%20soft%20bokeh%20background%2C%20elegant%20cinema%20aesthetic%2C%20professional%20video%20production%20mood&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '热门推荐',
  },
  {
    title: '红桃视频专区',
    desc: '红桃视频高清完整资源一网打尽，全部分类清晰呈现，支持快速检索，最新剧集电影随时畅享在线播放。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20red%20and%20gold%20abstract%20geometric%20composition%2C%20cinematic%20glow%20effect%2C%20luxury%20entertainment%20atmosphere%2C%20dark%20elegant%20backdrop%20with%20soft%20light%20rays%2C%20premium%20streaming%20visual&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '高清专区',
  },
  {
    title: '蜜桃视频合集',
    desc: '精心整理的蜜桃视频专题合集，按类型、热度、更新时间多维分类，找片看片更高效，收藏追剧更便捷。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20warm%20peach%20toned%20abstract%20film%20strip%20design%2C%20golden%20light%20reflections%2C%20cinematic%20deep%20shadows%2C%20elegant%20movie%20theater%20ambiance%2C%20professional%20film%20industry%20aesthetic&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '精选合集',
  },
  {
    title: '樱桃视频热榜',
    desc: '实时更新樱桃视频热门榜单，基于真实观看数据排名，热度趋势一目了然，帮你快速发现当下最火内容。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20crimson%20and%20cherry%20red%20abstract%20light%20streaks%2C%20cinematic%20ranking%20visualization%20concept%2C%20dynamic%20energy%20flow%2C%20modern%20streaming%20platform%20atmosphere%2C%20professional%20entertainment%20technology&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '实时热榜',
  },
  {
    title: '全网搜索聚合',
    desc: '神马视频智能聚合引擎覆盖全网水果视频品牌资源，一个搜索框找遍所有平台，海量内容精准直达。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20nodes%20with%20warm%20golden%20connections%2C%20cinematic%20dark%20background%2C%20modern%20search%20technology%20concept%2C%20elegant%20data%20flow%20visualization%2C%20premium%20tech%20entertainment%20mood&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '智能聚合',
  },
];

const commentData = [
  {
    name: '影迷小陈',
    text: '自从发现了神马视频，再也不用在好几个网站之间跳来跳去了。香蕉视频、红桃视频、蜜桃视频、樱桃视频一个站全搞定，更新速度还特别快，真心好用！',
    time: '2小时前',
  },
  {
    name: '追剧达人',
    text: '播放体验真的没话说，高清不缓冲，比我之前用的那些视频网站强太多了。水果视频品牌的内容这里都有，每天下班回家第一件事就是打开神马视频。',
    time: '5小时前',
  },
  {
    name: '老司机阿杰',
    text: '给身边朋友都推荐了神马视频，大家反馈都很好。分类清晰、搜索方便、播放流畅，这三个点就秒杀大多数同类网站了。希望越做越好！',
    time: '1天前',
  },
];

const mediaData = [
  {
    title: '本周最热精选合集',
    subtitle: '香蕉视频 · 热门推荐',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20amber%20and%20gold%20abstract%20composition%2C%20film%20texture%20overlay%2C%20dark%20elegant%20cinema%20backdrop%2C%20soft%20dramatic%20lighting%2C%20premium%20movie%20entertainment%20visual%20style&width=720&height=420&seq=media-01&orientation=landscape',
  },
  {
    title: '红桃视频高分推荐',
    subtitle: '红桃视频 · 口碑佳作',
    img: 'https://readdy.ai/api/search-image?query=Rich%20crimson%20and%20dark%20red%20abstract%20light%20reflections%2C%20cinematic%20film%20grain%20effect%2C%20elegant%20theater%20curtain%20mood%2C%20premium%20entertainment%20atmosphere%2C%20warm%20dramatic%20shadows&width=720&height=420&seq=media-02&orientation=landscape',
  },
  {
    title: '蜜桃视频独家策划',
    subtitle: '蜜桃视频 · 专题放送',
    img: 'https://readdy.ai/api/search-image?query=Soft%20peach%20and%20warm%20golden%20abstract%20geometric%20shapes%2C%20cinematic%20depth%20of%20field%2C%20dark%20luxurious%20backdrop%2C%20premium%20film%20production%20aesthetic%2C%20elegant%20streaming%20visual&width=720&height=420&seq=media-03&orientation=landscape',
  },
  {
    title: '樱桃视频新片速递',
    subtitle: '樱桃视频 · 每日更新',
    img: 'https://readdy.ai/api/search-image?query=Cherry%20red%20and%20dark%20wine%20abstract%20light%20rays%2C%20cinematic%20glow%20effect%2C%20modern%20digital%20entertainment%20concept%2C%20dark%20elegant%20atmosphere%2C%20professional%20film%20visual%20style&width=720&height=420&seq=media-04&orientation=landscape',
  },
  {
    title: '神马视频全网精选',
    subtitle: '聚合推荐 · 一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Golden%20network%20connections%20on%20dark%20cinematic%20background%2C%20abstract%20film%20reels%20floating%2C%20warm%20amber%20glow%2C%20premium%20entertainment%20technology%20concept%2C%20elegant%20streaming%20platform%20mood&width=720&height=420&seq=media-05&orientation=landscape',
  },
];

const rankingData = [
  { rank: 1, title: '本周最受关注影片TOP10', source: '香蕉视频', hot: '9.8万', change: 'hot', },
  { rank: 2, title: '红桃视频高分作品精选', source: '红桃视频', hot: '9.2万', change: 'up', },
  { rank: 3, title: '蜜桃视频独家首发合集', source: '蜜桃视频', hot: '8.5万', change: 'hot', },
  { rank: 4, title: '樱桃视频每日更新热榜', source: '樱桃视频', hot: '7.9万', change: 'up', },
  { rank: 5, title: '全网高分经典影片汇总', source: '神马视频', hot: '7.1万', change: 'new', },
  { rank: 6, title: '本周新入库内容速览', source: '神马视频', hot: '6.4万', change: 'new', },
];

const topicData = [
  { label: '香蕉视频', count: '12.8万' },
  { label: '红桃视频', count: '10.5万' },
  { label: '蜜桃视频', count: '9.2万' },
  { label: '樱桃视频', count: '8.7万' },
  { label: '高清电影', count: '15.3万' },
  { label: '热播剧集', count: '11.6万' },
  { label: '每日更新', count: '9.8万' },
  { label: '经典合集', count: '7.4万' },
  { label: '最新上映', count: '6.9万' },
  { label: '口碑推荐', count: '5.2万' },
];

const carouselData = [
  {
    title: '香蕉视频年度精选',
    desc: '精选香蕉视频全年最受欢迎内容，品质保证，一场不容错过的视觉盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20golden%20and%20amber%20abstract%20cinematic%20composition%2C%20elegant%20film%20reel%20and%20light%20streaks%2C%20dark%20luxurious%20backdrop%2C%20premium%20movie%20award%20atmosphere%2C%20professional%20entertainment%20visual&width=1000&height=560&seq=carousel-01&orientation=landscape',
  },
  {
    title: '红桃视频口碑佳作',
    desc: '红桃视频高分作品大集合，口碑爆棚的诚意之作，每一部都值得细细品味。',
    img: 'https://readdy.ai/api/search-image?query=Rich%20crimson%20red%20abstract%20light%20reflections%20on%20dark%20background%2C%20cinematic%20depth%2C%20elegant%20theater%20curtain%20drape%20mood%2C%20premium%20film%20festival%20aesthetic%2C%20warm%20dramatic%20shadows&width=1000&height=560&seq=carousel-02&orientation=landscape',
  },
  {
    title: '蜜桃视频独家策划',
    desc: '蜜桃视频特别企划专题，深度整合优质内容，发现更多值得关注的精彩作品。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20peach%20and%20warm%20golden%20abstract%20geometric%20patterns%2C%20cinematic%20light%20leaks%2C%20dark%20elegant%20composition%2C%20premium%20film%20production%20concept%2C%20luxurious%20entertainment%20visual&width=1000&height=560&seq=carousel-03&orientation=landscape',
  },
  {
    title: '樱桃视频新片速递',
    desc: '樱桃视频最新入库内容实时追踪，紧跟更新节奏，第一时间发现新鲜好片。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cherry%20red%20dynamic%20abstract%20light%20trails%2C%20cinematic%20motion%20blur%20effect%2C%20modern%20digital%20streaming%20concept%2C%20dark%20elegant%20atmosphere%2C%20professional%20video%20entertainment%20mood&width=1000&height=560&seq=carousel-04&orientation=landscape',
  },
  {
    title: '神马视频全网聚合',
    desc: '神马视频智能聚合引擎实时同步四大品牌最新内容，一个平台看遍全网精彩。',
    img: 'https://readdy.ai/api/search-image?query=Golden%20interconnected%20network%20nodes%20on%20dark%20cinematic%20backdrop%2C%20abstract%20data%20flow%20visualization%2C%20warm%20amber%20glow%2C%20premium%20technology%20and%20entertainment%20fusion%2C%20elegant%20streaming%20platform%20concept&width=1000&height=560&seq=carousel-05&orientation=landscape',
  },
];

const featureData = [
  {
    icon: 'ri-movie-2-line',
    title: '品牌全覆盖',
    desc: '香蕉视频、红桃视频、蜜桃视频、樱桃视频四大水果视频品牌资源一站聚合，无需切换平台。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清不缓冲',
    desc: '采用先进CDN加速与智能码率适配技术，1080P高清画质流畅播放，告别卡顿等待。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日实时更新',
    desc: '内容库7×24小时持续刷新，与各大品牌平台保持同步，最新影片第一时间呈现。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    desc: '支持桌面端、移动端、平板多设备访问，观影记录与收藏跨端同步，随时随地继续观看。',
  },
];

const updateData = [
  { date: '2026-07-30', text: '神马视频内容库突破10万+，覆盖四大水果视频品牌最新资源，更新频率再创新高。', tag: '里程碑' },
  { date: '2026-07-28', text: '香蕉视频本周热门内容已同步更新，新增高清影片120+部，即刻在线观看。', tag: '更新' },
  { date: '2026-07-25', text: '红桃视频专区全新改版上线，优化分类导航与搜索体验，找片更高效。', tag: '功能' },
  { date: '2026-07-22', text: '蜜桃视频独家策划专题「夏日精选」正式上线，涵盖六大热门分类精选内容。', tag: '专题' },
  { date: '2026-07-19', text: '樱桃视频播放线路全面升级，新增多条高速CDN节点，观看体验大幅提升。', tag: '优化' },
  { date: '2026-07-16', text: '神马视频移动端适配完成2.0版本迭代，新增夜间模式与离线收藏功能。', tag: '产品' },
  { date: '2026-07-13', text: '全网搜索聚合引擎升级至v3.0，支持跨品牌智能联想搜索，结果更精准。', tag: '技术' },
  { date: '2026-07-10', text: '用户反馈系统正式上线，欢迎大家对内容质量与播放体验提出宝贵意见。', tag: '公告' },
  { date: '2026-07-06', text: '红桃视频年度口碑佳作合集上线，包含200+部高分经典作品，不容错过。', tag: '合集' },
];

const faqData = [
  {
    q: '神马视频是否需要注册才能观看？',
    a: '不需要。神马视频作为视频聚合平台，所有内容均可免费在线观看，无需注册账号，打开即看。我们致力于为用户提供最便捷的观影体验。',
  },
  {
    q: '为什么选择神马视频而不是直接访问各品牌网站？',
    a: '神马视频将香蕉视频、红桃视频、蜜桃视频、樱桃视频四大品牌资源聚合在一个平台，免去多个网站之间切换的麻烦。同时我们提供统一的搜索、分类和播放体验。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '神马视频采用多线路智能切换技术，如遇卡顿可尝试切换备用播放线路。建议在网络环境良好的情况下选择高清画质，以获得最佳观看体验。',
  },
  {
    q: '内容更新频率如何？',
    a: '我们与各大品牌平台保持实时同步，每日更新数百部最新影片资源。热门内容优先推送，确保用户第一时间获取最新最热的视频内容。',
  },
  {
    q: '是否支持手机和平板观看？',
    a: '完全支持。神马视频已完成移动端全面适配，支持iOS和Android设备浏览器访问。无论使用手机还是平板，都能获得流畅的高清观影体验。',
  },
];

const indexData = [
  { label: '香蕉视频热播', icon: 'ri-fire-line' },
  { label: '红桃视频精选', icon: 'ri-star-line' },
  { label: '蜜桃视频合集', icon: 'ri-folder-video-line' },
  { label: '樱桃视频新片', icon: 'ri-movie-line' },
  { label: '高清电影大全', icon: 'ri-film-line' },
  { label: '热播剧集追踪', icon: 'ri-tv-2-line' },
  { label: '每日更新速递', icon: 'ri-calendar-check-line' },
  { label: '全网搜索入口', icon: 'ri-search-eye-line' },
];

export default function Home() {
  const [headerScrolled, setHeaderScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setHeaderScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-800 font-sans">
      {/* ==================== HEADER ==================== */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          headerScrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-[60px] md:h-[72px]">
            {/* Logo */}
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}
              className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer"
            >
              <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-lg md:text-xl"></i>
              </div>
              <span className="text-lg md:text-xl font-bold text-foreground-950 tracking-tight">
                神马视频
              </span>
            </a>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map((item) => (
                <a
                  key={item.href}
                  href={`#${item.href}`}
                  onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                  className="px-3 py-2 text-sm font-medium text-foreground-500 hover:text-foreground-950 rounded-md hover:bg-background-200/70 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu Panel */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/60">
            <nav className="px-4 py-3 flex flex-col gap-1">
              {navLinks.map((item) => (
                <a
                  key={item.href}
                  href={`#${item.href}`}
                  onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                  className="px-3 py-2.5 text-sm font-medium text-foreground-500 hover:text-foreground-950 rounded-md hover:bg-background-200/70 transition-all cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </header>

      <main>
        {/* ==================== HERO ==================== */}
        <section
          id="hero"
          className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
        >
          {/* Background */}
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20warm%20red%20and%20amber%20glowing%20light%20streaks%2C%20elegant%20geometric%20shapes%2C%20premium%20movie%20entertainment%20atmosphere%2C%20deep%20shadows%20with%20subtle%20golden%20highlights%2C%20professional%20film%20industry%20aesthetic%2C%204k%20cinematic%20quality%20visual&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
              alt="神马视频平台主视觉"
              className="w-full h-full object-cover object-top"
              onError={handleImgError}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-background-50"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/30"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-20 md:py-24">
            <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              {/* Left Text */}
              <div className="flex-1 w-full text-center lg:text-left">
                <span className="inline-block px-4 py-1.5 bg-primary-500/20 text-primary-400 rounded-full text-xs font-semibold tracking-wide uppercase mb-5">
                  全网水果视频品牌聚合
                </span>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight mb-4">
                  神马视频 - 高清视频免费在线聚合平台
                </h1>
                <p className="text-base md:text-lg text-foreground-400 font-medium mb-4">
                  香蕉视频、红桃视频、蜜桃视频、樱桃视频，一站聚合，全网畅看
                </p>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-6">
                  神马视频是专注于水果视频品牌资源聚合的在线观看平台，覆盖香蕉视频、红桃视频、蜜桃视频、樱桃视频等主流品牌的高清内容。
                  每日实时同步更新，提供流畅不缓冲的观影体验。无论是最新热播剧集还是经典高分电影，一个网站全部搞定。
                </p>

                {/* Stats */}
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
                  <div className="text-center lg:text-left">
                    <div className="text-xl md:text-2xl font-bold text-accent-500">4大</div>
                    <div className="text-xs text-foreground-500">主流品牌覆盖</div>
                  </div>
                  <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
                  <div className="text-center lg:text-left">
                    <div className="text-xl md:text-2xl font-bold text-accent-500">500+</div>
                    <div className="text-xs text-foreground-500">日均更新影片</div>
                  </div>
                  <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
                  <div className="text-center lg:text-left">
                    <div className="text-xl md:text-2xl font-bold text-accent-500">10万+</div>
                    <div className="text-xs text-foreground-500">内容资源库</div>
                  </div>
                </div>

                {/* CTAs */}
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#app"
                    onClick={(e) => { e.preventDefault(); scrollToSection('app'); }}
                    className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
                  >
                    立即体验
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                  <a
                    href="#ranking"
                    onClick={(e) => { e.preventDefault(); scrollToSection('ranking'); }}
                    className="w-full sm:w-auto px-8 py-3 bg-background-200/80 hover:bg-background-300/80 text-foreground-800 font-medium rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
                  >
                    浏览榜单
                    <i className="ri-arrow-down-line ml-2"></i>
                  </a>
                </div>
              </div>

              {/* Right Visual */}
              <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
                <div className="relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20floating%20film%20strips%20and%20geometric%20shapes%20with%20warm%20red%20and%20golden%20accents%2C%20elegant%20abstract%20entertainment%20technology%20visual%2C%20premium%20movie%20streaming%20concept%2C%20deep%20shadows%20with%20soft%20glowing%20highlights%2C%204k%20quality&width=800&height=600&seq=hero-visual-right&orientation=landscape"
                    alt="神马视频聚合平台视觉展示"
                    className="w-full h-auto rounded-xl"
                  onError={handleImgError}
                  />
                  <div className="absolute -bottom-3 -right-3 w-full h-full rounded-xl border border-primary-500/30 -z-10"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ==================== #cards ==================== */}
        <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[1280px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精选推荐</h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
                每日精选四大品牌优质内容，一站式发现精彩视频
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {cardData.slice(0, 3).map((card, i) => (
                <article key={i} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
                  <div className="relative overflow-hidden aspect-[16/10]">
                    <img src={card.img} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-md">{card.tag}</span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-400 transition-colors">{card.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                  </div>
                </article>
              ))}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
              {cardData.slice(3, 5).map((card, i) => (
                <article key={i + 3} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row">
                  <div className="relative overflow-hidden sm:w-2/5 aspect-[16/10] sm:aspect-auto">
                    <img src={card.img} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-md">{card.tag}</span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5 sm:w-3/5 flex flex-col justify-center">
                    <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-400 transition-colors">{card.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #app ==================== */}
        <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500/10 via-background-100 to-accent-500/10 rounded-2xl p-8 md:p-12 border border-background-200/60">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">移动客户端</h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-[520px] mx-auto lg:mx-0">
                  神马视频移动端已全面适配，支持iOS与Android设备浏览器直接访问。无需下载安装，打开即用，畅享全网水果视频品牌高清内容。夜间模式、离线收藏等贴心功能让移动观影更舒适便捷。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50 rounded-lg border border-background-200/60 cursor-pointer hover:border-primary-500/40 transition-all">
                    <i className="ri-apple-fill text-xl text-foreground-700"></i>
                    <span className="text-sm font-medium text-foreground-700">iOS 版本</span>
                  </div>
                  <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50 rounded-lg border border-background-200/60 cursor-pointer hover:border-primary-500/40 transition-all">
                    <i className="ri-android-fill text-xl text-foreground-700"></i>
                    <span className="text-sm font-medium text-foreground-700">Android 版本</span>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 w-full max-w-[300px] md:max-w-[360px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20mobile%20phone%20mockup%20displaying%20video%20streaming%20interface%20with%20warm%20red%20accents%2C%20elegant%20dark%20UI%20design%2C%20premium%20app%20presentation%2C%20floating%20phone%20with%20soft%20glow%2C%20minimal%20clean%20background&width=600&height=900&seq=app-mockup&orientation=portrait"
                  alt="神马视频移动端界面"
                  className="w-full h-auto"
                onError={handleImgError}
                />
              </div>
            </div>
          </div>
        </section>

        {/* ==================== #comments ==================== */}
        <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[1024px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">用户口碑</h2>
              <p className="text-sm md:text-base text-foreground-500">来自真实用户的使用反馈</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {commentData.map((c, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center">
                      <span className="text-accent-400 font-bold text-sm">{c.name.charAt(0)}</span>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-800">{c.name}</div>
                      <div className="text-xs text-foreground-500">{c.time}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
                  <div className="flex gap-1 mt-3">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #media ==================== */}
        <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精彩放送</h2>
              <p className="text-sm md:text-base text-foreground-500">热门内容抢先预览，点击探索更多精彩</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
              {mediaData.map((m, i) => (
                <div key={i} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
                  <div className="relative overflow-hidden aspect-[16/11]">
                    <img src={m.img} alt={m.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                      <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/90 opacity-0 group-hover:opacity-100 transition-opacity">
                        <i className="ri-play-fill text-background-50 text-lg md:text-xl ml-0.5"></i>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <h3 className="text-xs md:text-sm font-semibold text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-2 leading-snug">{m.title}</h3>
                    <p className="text-[10px] md:text-xs text-foreground-500 mt-1">{m.subtitle}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #contact ==================== */}
        <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[900px] mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-[500px] mx-auto">
              有内容推荐、合作意向或建议反馈？欢迎通过以下方式与我们取得联系
            </p>
            <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10">
                    <i className="ri-mail-line text-xl text-primary-400"></i>
                  </div>
                  <div className="text-sm font-semibold text-foreground-800 mb-1">内容投稿</div>
                  <div className="text-xs text-foreground-500">content@shenmashipin.com</div>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-500/10">
                    <i className="ri-group-line text-xl text-accent-400"></i>
                  </div>
                  <div className="text-sm font-semibold text-foreground-800 mb-1">商务合作</div>
                  <div className="text-xs text-foreground-500">biz@shenmashipin.com</div>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-500/10">
                    <i className="ri-question-answer-line text-xl text-secondary-400"></i>
                  </div>
                  <div className="text-sm font-semibold text-foreground-800 mb-1">建议反馈</div>
                  <div className="text-xs text-foreground-500">feedback@shenmashipin.com</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ==================== #about ==================== */}
        <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[900px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">关于神马</h2>
              <p className="text-sm md:text-base text-foreground-500">了解神马视频的品牌故事与平台理念</p>
            </div>
            <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
              <div className="prose prose-invert max-w-none">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  神马视频诞生于对优质视频内容聚合的追求。我们发现，用户常常需要在香蕉视频、红桃视频、蜜桃视频、樱桃视频等多个平台之间来回切换，不仅耗费时间，观看体验也支离破碎。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  因此，我们打造了神马视频——一个专注于水果视频品牌资源聚合的在线平台。通过智能聚合引擎，我们将四大主流品牌的高清内容整合在一起，提供统一搜索、智能分类和流畅播放体验。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  目前平台已收录超过10万部影片资源，每日保持500+部内容的更新频率。我们始终秉持「免费、高清、不缓冲」的服务理念，致力于成为用户观看水果视频品牌内容的首选入口。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ==================== #ranking ==================== */}
        <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[900px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热度榜单</h2>
              <p className="text-sm md:text-base text-foreground-500">基于真实数据的热门内容排行</p>
            </div>
            <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
              {rankingData.map((item, i) => (
                <a
                  key={i}
                  href="#media"
                  onClick={(e) => { e.preventDefault(); scrollToSection('media'); }}
                  className={`flex items-center gap-3 md:gap-4 px-5 md:px-6 py-3.5 md:py-4 hover:bg-background-200/50 transition-colors cursor-pointer ${
                    i < rankingData.length - 1 ? 'border-b border-background-200/40' : ''
                  }`}
                >
                  <div className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                    i === 0 ? 'bg-primary-500 text-background-50' :
                    i === 1 ? 'bg-primary-400 text-background-50' :
                    i === 2 ? 'bg-accent-500 text-background-50' :
                    'bg-background-200 text-foreground-500'
                  }`}>
                    {item.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm md:text-base font-semibold text-foreground-800 truncate">{item.title}</div>
                    <div className="text-xs text-foreground-500 mt-0.5">{item.source}</div>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    {item.change === 'hot' && <i className="ri-fire-fill text-primary-400 text-sm"></i>}
                    {item.change === 'up' && <i className="ri-arrow-up-fill text-accent-400 text-sm"></i>}
                    {item.change === 'new' && <span className="text-[10px] font-semibold px-1.5 py-0.5 bg-accent-500/20 text-accent-400 rounded">NEW</span>}
                    <span className="text-sm font-semibold text-foreground-600">{item.hot}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #topics ==================== */}
        <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[1000px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
              <p className="text-sm md:text-base text-foreground-500">大家都在关注的内容方向</p>
            </div>
            <div className="flex flex-wrap justify-center gap-3">
              {topicData.map((t, i) => (
                <a
                  key={i}
                  href="#cards"
                  onClick={(e) => { e.preventDefault(); scrollToSection('cards'); }}
                  className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-500/30 hover:bg-primary-500/5 transition-all duration-200 cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-400 transition-colors whitespace-nowrap">{t.label}</span>
                  <span className="text-xs text-foreground-500 bg-background-200/60 px-2 py-0.5 rounded-full">{t.count}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #carousel ==================== */}
        <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[1280px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">焦点专题</h2>
              <p className="text-sm md:text-base text-foreground-500">精选特色专题内容，发现更多精彩</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {carouselData.slice(0, 3).map((c, i) => (
                <article key={i} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
                  <div className="relative overflow-hidden aspect-[16/9]">
                    <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                      <h3 className="text-base md:text-lg font-bold text-white mb-1">{c.title}</h3>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{c.desc}</p>
                  </div>
                </article>
              ))}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
              {carouselData.slice(3, 5).map((c, i) => (
                <article key={i + 3} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row">
                  <div className="relative overflow-hidden sm:w-2/5 aspect-[16/9] sm:aspect-auto">
                    <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent sm:bg-gradient-to-r sm:from-transparent sm:to-black/60"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-3 sm:hidden">
                      <h3 className="text-sm font-bold text-white">{c.title}</h3>
                    </div>
                  </div>
                  <div className="p-4 md:p-5 sm:w-3/5 flex flex-col justify-center">
                    <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-400 transition-colors hidden sm:block">{c.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{c.desc}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #features ==================== */}
        <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[1100px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">平台优势</h2>
              <p className="text-sm md:text-base text-foreground-500">为什么选择神马视频</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {featureData.map((f, i) => (
                <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 text-center hover:border-primary-500/20 transition-all duration-300 cursor-pointer">
                  <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-500/10">
                    <i className={`${f.icon} text-xl md:text-2xl text-primary-400`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-800 mb-2">{f.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #updates ==================== */}
        <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[900px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">最新动态</h2>
              <p className="text-sm md:text-base text-foreground-500">平台更新与内容动态实时追踪</p>
            </div>
            <div className="relative">
              {/* Timeline line */}
              <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-px bg-background-200"></div>
              <div className="flex flex-col gap-4 md:gap-5">
                {updateData.map((u, i) => (
                  <div key={i} className="relative flex gap-4 md:gap-5 pl-12 md:pl-14">
                    <div className={`absolute left-[11px] md:left-[14px] w-4 h-4 rounded-full border-2 ${
                      i === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-100 border-background-300'
                    }`}></div>
                    <div className="flex-1 bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/60">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs text-foreground-500">{u.date}</span>
                        <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${
                          u.tag === '里程碑' ? 'bg-primary-500/20 text-primary-400' :
                          u.tag === '更新' ? 'bg-accent-500/20 text-accent-400' :
                          u.tag === '公告' ? 'bg-secondary-400/20 text-secondary-400' :
                          'bg-background-200 text-foreground-500'
                        }`}>{u.tag}</span>
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed">{u.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ==================== #faq ==================== */}
        <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-[800px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
              <p className="text-sm md:text-base text-foreground-500">快速了解神马视频的使用方式</p>
            </div>
            <div className="flex flex-col gap-3 md:gap-4">
              {faqData.map((item, i) => (
                <div
                  key={i}
                  className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                    onClick={() => setFaqOpen(faqOpen === i ? null : i)}
                  >
                    <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.q}</h3>
                    <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                      faqOpen === i ? 'rotate-45' : ''
                    }`}>
                      <i className="ri-add-line text-foreground-500"></i>
                    </div>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      faqOpen === i ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== #index ==================== */}
        <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-[1000px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">内容导航</h2>
              <p className="text-sm md:text-base text-foreground-500">快速找到你感兴趣的内容分类</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
              {indexData.map((item, i) => (
                <a
                  key={i}
                  href="#cards"
                  onClick={(e) => { e.preventDefault(); scrollToSection('cards'); }}
                  className="group flex items-center gap-3 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-500/30 hover:bg-primary-500/5 transition-all duration-200 cursor-pointer"
                >
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors flex-shrink-0">
                    <i className={`${item.icon} text-lg text-primary-400`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">{item.label}</span>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* ==================== FOOTER ==================== */}
      <footer id="footer" className="bg-background-100 border-t border-background-200/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-foreground-950">神马视频</span>
              </div>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4">
                神马视频聚合香蕉视频、红桃视频、蜜桃视频、樱桃视频等水果视频品牌高清内容，免费在线观看，高清不缓冲，一站畅享全网精彩视频。
              </p>
              <div className="flex gap-3">
                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer"><i className="ri-wechat-line"></i></a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer"><i className="ri-weibo-line"></i></a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer"><i className="ri-earth-line"></i></a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                {navLinks.slice(1, 5).map((item) => (
                  <a
                    key={item.href}
                    href={`#${item.href}`}
                    onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                    className="text-xs md:text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Content Brands */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">内容品牌</h4>
              <div className="flex flex-col gap-2.5">
                <span className="text-xs md:text-sm text-foreground-500">香蕉视频</span>
                <span className="text-xs md:text-sm text-foreground-500">红桃视频</span>
                <span className="text-xs md:text-sm text-foreground-500">蜜桃视频</span>
                <span className="text-xs md:text-sm text-foreground-500">樱桃视频</span>
              </div>
            </div>

            {/* Partners */}
            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">合作伙伴</h4>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                诚邀各大视频平台与内容创作者加入合作，共同为用户提供更丰富的观影选择。
              </p>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 神马视频 - 高清视频免费在线聚合平台。本站内容来源于网络公开资源。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-700 transition-colors">服务条款</span>
              <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-700 transition-colors">隐私政策</span>
              <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-700 transition-colors">免责声明</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}